import { selectPaymentConfig, useAppInitStore } from '../../stores';

export const usePaymentPublicKey = () => {
	const paymentPublicKeys = useAppInitStore(selectPaymentConfig);

	const PaymentKey = 'Payment:Checkout:PublicKey';

	const paymentPublicKey =
		paymentPublicKeys.find((payment) => {
			return payment.key === PaymentKey;
		})?.value ?? '';

	return { paymentPublicKeys, paymentPublicKey };
};
